import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { s as setIcon } from './icons-3c94a1f0.js';
import Icon from './Icon.js';
import { a as addClassNames, c as classNamePropTypes } from './classNames-1ed461aa.js';
import { a as addSpacingClasses, m as marginPropTypes } from './spacing-0f39ba4a.js';

function Input({
  className,
  margin,
  type,
  error,
  disabled,
  icon,
  componentRef,
  suffix,
  ...otherProps
}) {
  let cssClasses = ['st_input', 'st_focusable'];
  cssClasses = addClassNames(className, cssClasses);
  const inputProps = {};
  if (margin) cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  if (error) {
    inputProps['aria-invalid'] = !!error;
    cssClasses.push('st_input--invalid');
  }
  if (disabled) {
    inputProps.disabled = disabled;
    cssClasses.push('st_input--disabled');
  }
  if (icon || suffix) {
    let inputIcon = null;
    if (icon) {
      inputIcon = setIcon(Icon, icon, {
        className: 'st_input__icon'
      });
      cssClasses.push('st_input--withicon');
    }
    cssClasses.push('st_inputwrapper');
    cssClasses.push('st_focusable-within');
    return /*#__PURE__*/React.createElement("div", {
      className: cssClasses.join(' ')
    }, /*#__PURE__*/React.createElement("input", _extends({
      type: type,
      ref: componentRef
    }, inputProps, otherProps, {
      className: "st_input--invisible"
    })), inputIcon, suffix && /*#__PURE__*/React.createElement("span", {
      className: "st_input__suffix"
    }, suffix));
  }
  return /*#__PURE__*/React.createElement("input", _extends({
    ref: componentRef,
    type: type,
    className: cssClasses.join(' ')
  }, inputProps, otherProps));
}
Input.propTypes = {
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** type of input */
  type: PropTypes.string,
  /** margin for box, if any */
  margin: marginPropTypes,
  /** whether input is invalid, e.g. error state */
  error: PropTypes.bool,
  /** whether input is disabled */
  disabled: PropTypes.bool,
  /** optional icon. A screentone icon component, e.g. IconStar */
  icon: PropTypes.any,
  /** ref for element */
  componentRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  /** optional text suffix */
  suffix: PropTypes.string
};
Input.defaultProps = {
  className: null,
  margin: null,
  type: 'text',
  error: false,
  disabled: false,
  icon: null,
  componentRef: null,
  suffix: null
};

export { Input as I };
